import React from 'react';
import Typography from '@material-ui/core/Typography';
import useSort from '../../crud/useSort';
import DataTable from '../../Common/DataTable';
import {formataMoeda} from '../../Helpers/money';
import {formata} from '../../Helpers/date';
import { MesExtenso } from '../../Helpers/date';
import {get} from 'lodash-es';

export default function MostraEncargo (props) {
  const { data:data_={}, attrKey, attr, dados:dados_={} } = props;
  const { ano, mes } = dados_;
  let { dados, totais } = data_;
  if (!dados) return null;
  dados = dados.filter(o => get(o, attrKey, 0) != 0);
  const { data:sortedData, setSort, sort } = useSort(dados);
  return (
    <div style={{
      // width: "100%",
      // maxWidth: "550px",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      paddingTop: "10px",
      paddingBottom: "10px",
    }}>
      <Typography variant="display2">Encargos</Typography>
      <Typography variant="display1">{attr} {MesExtenso(mes-1)}/{ano}</Typography>
      {/* <div style={{ width: "95%" }}> */}
      <div>
        <DataTable 
          cols={["270px", "80px", "100px", "100px"]}
          title={[ "Nome", "Pago em", "Tipo", attr ]}
          dataIdx={[ "Nome", "DataPagto", "Processo", attrKey ]}
          align={{ [attrKey]: "right" }}
          lastLine={totais}
          sort={sort}
          setSort={setSort}
          data={sortedData}
          modif={{
            DataPagto: formata,
            [attrKey]: formataMoeda
          }}
        />
      </div>
    </div>
  )
}
